"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _radium = _interopRequireDefault(require("radium"));

var _EmailCaptureCss = _interopRequireDefault(require("./EmailCapture.css.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormSubmit = function FormSubmit(_ref) {
  var disabledState = _ref.disabledState,
      onSubmit = _ref.onSubmit,
      onOptOut = _ref.onOptOut,
      theme = _ref.theme;

  var handleDisabledClick = function handleDisabledClick(e) {
    e.preventDefault();
    e.stopPropagation();
    console.log('enter email to submit!');
    return;
  };

  var themedButton = Object.assign({}, _EmailCaptureCss.default['submitButton'], _EmailCaptureCss.default["".concat(theme, "Button")]);
  return /*#__PURE__*/_react.default.createElement("div", {
    key: "email-submit-buttons",
    style: _EmailCaptureCss.default.formButtons
  }, /*#__PURE__*/_react.default.createElement("button", {
    key: "submit-button-el",
    style: disabledState ? _EmailCaptureCss.default['disabledButton'] : themedButton,
    onClick: disabledState ? handleDisabledClick : onSubmit
  }, /*#__PURE__*/_react.default.createElement("span", {
    key: "submit-button-text",
    style: _EmailCaptureCss.default.buttonText
  }, "Next"), /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    key: "submit-button-icon",
    icon: ['fal', 'angle-double-right'],
    style: _EmailCaptureCss.default.submitButtonIcon
  })), /*#__PURE__*/_react.default.createElement("button", {
    key: "no-submit-button",
    style: _EmailCaptureCss.default.noButton,
    onClick: onOptOut
  }, "No Thanks"));
};

var _default = (0, _radium.default)(FormSubmit);

exports.default = _default;

//# sourceMappingURL=FormSubmit.jsx.map